
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createCrudHooks, processResult, STALE_TIME } from "../common/queries";
import api from "../http-common";

export const userApi = {
	...createCrudHooks({
		baseKey: "users",
		basePath: "/users",
	}),

	useMe() {
		const qc = useQueryClient();
		return useQuery({
			queryKey: ["users", "me"],
			queryFn: () => api.get("/users/me").then(r => processResult(qc, r)),
			staleTime: STALE_TIME,
		});
	},

	useCatchup() {
		const qc = useQueryClient();
		return useQuery({
			queryKey: ["users", "catchup"],
			queryFn: () => api.get("/users/me/catchup").then(r => processResult(qc, r)),
			staleTime: STALE_TIME,
		});
	},

	useUpcoming() {
		const qc = useQueryClient();
		return useQuery({
			queryKey: ["users", "upcoming"],
			queryFn: () => api.get("/users/me/upcoming").then(r => processResult(qc, r)),
			staleTime: STALE_TIME,
		});
	},

	useCalendar(from, to) {
		const qc = useQueryClient();
		return useQuery({
			queryKey: ["users", "calendar", from, to],
			queryFn: () => api.get(`/users/me/calendar/${from}/${to}`).then(r => processResult(qc, r)),
			staleTime: STALE_TIME,
			keepPreviousData: true,
			enabled: !!from && !!to,
		});
	},

	useSetPreference() {
		const qc = useQueryClient();
		return useMutation({
			mutationFn: ({ key, value }) => api.post(`/users/me/preferences/${key}/${value}`).then(r => processResult(qc, r)),
			onMutate: async ({ key, value }) => {
				await qc.cancelQueries(["users", "me"])
				const previous = qc.getQueryData(["users", "me"]);
				qc.setQueryData(["users", "me"], (old) =>
					old ? { ...old, [key]: value } : old
				)
				return { previous };
			},
		});
	},
};
